import "./FacilitiesCenters.module.css";
import Header from "@/reusable_sections/Header";
import CentersHero from "./sections/CentersHero";
import Facilities from "./sections/Facilities";
import Centers from "./sections/Centers";
import Consultation from "./sections/Consultation";
import FindRightCenter from "./sections/FindRightCenter";
import BeyondRobotics from "./sections/BeyondRobotics";
import Footer from "@/reusable_sections/Footer";
export default function FacilitiesCentersPage() {
  return <div>
      <Header />
      <CentersHero />
      <Facilities />
      <Centers />
      <FindRightCenter />
      <Consultation />
      <BeyondRobotics />
      <Footer />
    </div>;
}